import React, { useContext } from 'react';
import styles from '../../css/components/footers/scrollablePageFooter.css';
import { useTranslation } from 'react-i18next';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

function MoreGamesLinkList( ) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const { t } = useTranslation('translation');

	const gameLinks = onelpsParams.otherGames;

	return (
		<ul data-testid="moreGamesLinkList">
			<li className={styles.withoutDelimiter}>{t('footer.moreGames')}</li>
			{Object.keys(gameLinks).map((gameId, i) => (
				<li key={i}>
					<a
						href={gameLinks[gameId].url}
						target="_blank"
						rel="noopener noreferrer"
					>
						{gameLinks[gameId].name}
					</a>
				</li>
			))}
		</ul>
	);
}

export default MoreGamesLinkList;
